'use client';

import dynamic from 'next/dynamic';
import { Container } from '@mui/material';

// Only rendered for first-time voice users; keep it (and the onboarding-demo code it pulls in) out of the root layout bundle.
const StepActivate = dynamic(
  () => import('@/app/account/voice-subscription/onboarding-demo/StepActivate').then((m) => m.StepActivate),
  { ssr: false },
);

export type VoiceOnboardingGateProps = {
  /** When true, replace page content with first-time vertical onboarding. */
  active: boolean;
  activating?: boolean;
  onActivate: (verticalKey: string, bandKey: string) => void | Promise<void>;
  children: React.ReactNode;
};

/**
 * Blocks all voice-module pages until the account starts a trial.
 * Same StepActivate UI as Voice Subscription for first-time users.
 */
export function VoiceOnboardingGate({
  active,
  activating = false,
  onActivate,
  children,
}: VoiceOnboardingGateProps) {
  if (!active) return <>{children}</>;

  return (
    <Container maxWidth={false} sx={{ py: 4 }}>
      <StepActivate
        goto={() => {}}
        activating={activating}
        onActivate={onActivate}
      />
    </Container>
  );
}
